import React from "react";
import {Button, FormCard} from "@reside/ui";
import {Formik} from "formik";
import {EventTriggerForm} from "../../services/HubAndSpokeService";
import {EventTriggersFormFields} from "./EventTriggersFormFields";
import {useCreateEventTrigger} from "./hooks/useCreateEventTrigger";
import {FormWrapper} from "./styles";
import {generatePathPreview, validate} from "./helpers";
import {useTestUpload} from "./hooks/useTestUpload";

const DOCUMENT_PATH =
  "{facility-name}/example_form_{current-date}-{resident-name}.pdf";

export const EventTriggerCreate = () => {
  // Custom hook for creating event triggers
  const {mutate: createEventTrigger, isLoading: isCreating} =
    useCreateEventTrigger();

  // Custom hook for testing file uploads
  const {mutate: testUpload} = useTestUpload();

  return (
    <FormWrapper>
      {/* FormCard component for structuring the form */}
      <FormCard title="Create Event Trigger">
        {/* Formik component for form state management and validation */}
        <Formik<EventTriggerForm>
          enableReinitialize
          initialValues={{
            templateName: "",
            document: "",
            template_field_id: "",
            facilities: [],
            sftp_config_id: "",
            document_path: DOCUMENT_PATH,
            upload_on: ["admission_approval"],
          }}
          // Empty onSubmit due to a Formik issue (see comment below)
          // https://github.com/jaredpalmer/formik/issues/2675
          onSubmit={() => {
            return;
          }}
          validate={validate}
        >
          {({values}) => (
            <>
              {/* Button for testing file upload */}
              <Button
                style={{position: "absolute", top: "65px", right: "50px"}}
                color="primary"
                onClick={() =>
                  testUpload({
                    sftp_config_id: values.sftp_config_id,
                    target_path: generatePathPreview(values.document_path),
                  })
                }
              >
                Test upload
              </Button>
              {/* Custom component for rendering form fields */}
              <EventTriggersFormFields
                isLoading={isCreating}
                onSubmit={values => createEventTrigger(values)}
              />
            </>
          )}
        </Formik>
      </FormCard>
    </FormWrapper>
  );
};
